<template>
    <div class="main-partners__container pointer-events-none">
        <Carousel
            v-if="isCarouselReady"
            :value="partners"
            :num-visible="settings.slidesToShow"
            :responsive-options="settings.responsive"
            :show-indicators="false"
            :show-navigators="false"
            :autoplay-interval="5000"
        >
            <template #item="{data}">
                <div class="flex align-items-center">
                    <img
                        :src="getImageUrl(data.img)"
                        :alt="data.alt"
                        :width="data.width"
                        :height="data.height"
                    />
                </div>
            </template>
        </Carousel>
        <div
            v-else
            class="main-partners__placeholder flex flex-wrap justify-content-center column-gap-4 row-gap-3"
            aria-hidden="true"
        >
            <img
                v-for="partner in partners"
                :key="partner.img"
                :src="getImageUrl(partner.img)"
                :alt="partner.alt"
                :width="partner.width"
                :height="partner.height"
            />
        </div>
        <span>{{ $t('lang.pages.common.blocks.mainPartners.description') }}</span>
    </div>
</template>

<script>
import { nextTick } from 'vue';
import Carousel from "primevue/carousel";

export default {
    name: "BlockMainPartners",
    data() {
        return {
            isCarouselReady: false,
            imgDirectoryPath: '/i/partners/',
            partners: [
                {img: 'mvidio.webp', alt: 'м.видео', width: 200, height: 113},
                {img: 'ozon.webp', alt: 'ozon', width: 141, height: 55},
                {img: 'banki.webp', alt: 'banki.ru', width: 140, height: 55},
                {img: 'wink.webp', alt: 'wink', width: 141, height: 55},
                {img: 'flowwow.webp', alt: 'flowwow', width: 141, height: 55},
                {img: 'textru.webp', alt: 'text.ru', width: 140, height: 55},
                {img: 'etazhi.webp', alt: 'этажи', width: 141, height: 55},
                {img: 'telderi.webp', alt: 'telderi', width: 141, height: 55},
                {img: 'kokos.webp', alt: 'kokos.com', width: 140, height: 55},
                {img: 'kite.webp', alt: 'kite', width: 140, height: 55},
            ],
            settings: {
                slidesToShow: 8,
                responsive: [
                    {
                        breakpoint: '1199px',
                        numVisible: 8,
                        numScroll: 1,
                    },
                    {
                        breakpoint: '991px',
                        numVisible: 6,
                        numScroll: 1,
                    },
                    {
                        breakpoint: '767px',
                        numVisible: 5,
                        numScroll: 1,
                    },
                    {
                        breakpoint: '599px',
                        numVisible: 4,
                        numScroll: 1,
                    },
                    {
                        breakpoint: '479px',
                        numVisible: 3,
                        numScroll: 1,
                    }
                ]
            }
        };
    },
    methods: {
        getImageUrl(img) {
            return this.imgDirectoryPath + img;
        },
        scheduleCarouselInit() {
            const activate = () => {
                this.isCarouselReady = true;
            };

            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(activate, { timeout: 1500 });
                return;
            }

            nextTick(() => requestAnimationFrame(activate));
        },
    },
    mounted() {
        this.scheduleCarouselInit();
    },
    components: {
        Carousel,
    }
}
</script>

<style scoped>
.main-partners__container {
    border-top: 1px solid #747474;
    flex: 1 1 auto;
    padding: 46px 0;
}
.main-partners__container img {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    opacity: 0.5;
    transition: all 0.3s;
    height: 37px;
    width: auto; /* intrinsic width/height в HTML — без squash aspect-ratio */
}
.main-partners__placeholder img {
    pointer-events: none;
}
.main-partners__container img:hover {
    filter: unset !important;
    opacity: unset !important;
}
:deep(.p-carousel .p-carousel-item) {
    display: flex;
    justify-content: center;
    flex-grow: 1;
}
.main-partners__container > span {
    display: block;
    text-align: center;
    margin-top: 24px;
    opacity: .5;
    font-size: 13px;
    font-weight: 300;
}
@media (max-width: 991px) {
    .main-partners__container {
        padding: 42px 0 7px;
    }
}
@media (max-width: 480px) {
    .main-partners__container {
        padding: 10px 0;
    }
}
</style>
